var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497ZM6.7273 5.45455C6.7273 5.07273 6.47276 4.81818 6.09094 4.81818C5.70912 4.81818 5.45457 5.07273 5.45457 5.45455V10.5455C5.45457 10.9273 5.70912 11.1818 6.09094 11.1818C6.47276 11.1818 6.7273 10.9273 6.7273 10.5455V5.45455ZM10.5455 5.45455C10.5455 5.07273 10.2909 4.81818 9.90912 4.81818C9.5273 4.81818 9.27276 5.07273 9.27276 5.45455V10.5455C9.27276 10.9273 9.5273 11.1818 9.90912 11.1818C10.2909 11.1818 10.5455 10.9273 10.5455 10.5455V5.45455Z",
    fill: "#7FC112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.e14f1d72ce082a1b788590feddf2e2ae.svg";
export { ForwardRef as ReactComponent };